import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";

export default function CategoryStrip() {
  return (
    <section className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="主题分类"
        title="按兴趣找话题"
        subtitle="六个常驻栏目覆盖娱乐、影视、网络、社会、游戏与消费场景，每个栏目都保留完整的评论区与投票记录。"
        linkTo="/topics"
        linkLabel="进入话题广场"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((category, index) => (
          <Link
            key={category.slug}
            to={`/topics?category=${category.slug}`}
            className="group flex cursor-pointer items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
          >
            <span
              className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md ${
                index % 3 === 0
                  ? "bg-primary-50 text-primary-600"
                  : index % 3 === 1
                    ? "bg-secondary-50 text-secondary-600"
                    : "bg-accent-50 text-accent-700"
              }`}
            >
              <i className={`${category.icon} text-xl`} aria-hidden="true" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center justify-between gap-2">
                <span className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {category.name}
                </span>
                <span className="shrink-0 font-label text-xs text-foreground-400">
                  {category.count} 个话题
                </span>
              </span>
              <span className="mt-2 block text-sm leading-relaxed text-foreground-600">
                {category.description}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}